export default __webpack_public_path__ + "static/Default-Preview-65ebdaa0f4a91316d9e24e22a9987d32.png";